const InvestmentsChallenge1HintsText =
    ["Mutual Funds do not give you voting rights. ",
     "Stocks do not have an expiration date. " , 
     "Only real estate gives you the opportunity to make rental income. ",
     "The price (cost) of bonds does not typically fluctuate." 
    ]
   

export default InvestmentsChallenge1HintsText;